import {
    DeadlineFilterItemType,
    DeadlineListElementSubjectElementType,
    DeadlineListElementType,
    DeadlineListMapType,
    DeadlineSaveExchangeElementType,
    DeadlineSearchParamType,
    DeadlineUpdateProgressElementType
} from "../interface";
import moment from "moment";

export const deadlineSearchParamInit: DeadlineSearchParamType = {
    endFlag: "N",
    endType: "2", // 내부수정: 기본 월마감
    fromDate: moment().subtract(1, "months").startOf("months").format("YYYY-MM-DD"),
    limit: 10,
    pageNo: 1,
    toDate: moment().endOf("month").format("YYYY-MM-DD"), // 당월 말일
    //내부수정: 키워드 초기화
    keyword1: "",
    keywordType1: "1",
    keyword2: "",
    keywordType2: "1",
}

export const deadlineFilterItemInit: DeadlineFilterItemType = {
    taxEndDateId: 0,
    taxEndDate: "",
    newDExchangeRate: 0,

    rateFlag: "1",
    rateFromDate: "",
    rateToDate: ""
}

export const deadlineSaveExchangeElementInit: DeadlineSaveExchangeElementType = {
    newDExchangeRate: 0,
    newShipmentId: ""
}

export const deadlineUpdateProgressElementInit: DeadlineUpdateProgressElementType = {
    endFlag: "",
    newShipmentId: ""
}

export const deadlineListMapInit: DeadlineListMapType = {
    list: [],
    totalCount: 0
}

export const deadlineListElementInit: DeadlineListElementType = {
    currencyName: "",
    customerName: "",
    endDt: "",
    endType: "",
    endFlag: "",
    endState: "",
    enduserName: "",
    newDAmount: 0,
    newDExchangeRate: 0,
    newDtOrder: "",
    newDtShipment: "",
    newLCustomerValue: "",
    newLEnduserValue: "",
    newLVatValue: "",
    newPProgress: 0,
    newShipmentId: "",
    orderSubjectResList: [],
    orderTypeName: "",
    owneridValue: "",
    owningUserName: "",
    progressName: "",
    taxTotal: 0,
    totalAmount: 0
}

export const deadlineListElementSubjectElementInit: DeadlineListElementSubjectElementType = {
    _new_l_erp_product_value: "",
    _new_l_shipment_value: "",
    currencyName: "",
    newTxtNmItem: "",
    new_d_exchange_rate: 0,
    new_d_total: 0,
    new_d_unitprice: 0,
    new_d_won: 0,
    new_i_qty: 0,
    new_p_currency: "",
    new_shipment_subjectid: "",
    new_txt_standard: ""
}